import { render, staticRenderFns } from "./SingleCatalogSubgroupSelectorTree.vue?vue&type=template&id=0500d639&scoped=true&"
import script from "./SingleCatalogSubgroupSelectorTree.vue?vue&type=script&lang=js&"
export * from "./SingleCatalogSubgroupSelectorTree.vue?vue&type=script&lang=js&"
import style0 from "./SingleCatalogSubgroupSelectorTree.vue?vue&type=style&index=0&id=0500d639&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0500d639",
  null
  
)

export default component.exports